import MuiBaseModal from "../../common/modal/MuiModal";
import { PartnerSchema } from "../../../services/Schemas/Partner";
import CreatePartnerForm from "../../../forms/partner-edit-create/CreatePartnerForm";

interface ICreateRole {
  onClose: (payload: boolean) => void;
  handleReload?: () => void;
  roleInfo?: Partial<PartnerSchema>;
  open: boolean;
}

export default function CreatePartnerModal({
  onClose,
  open,
  roleInfo,
  handleReload,
}: ICreateRole) {
  return (
    <MuiBaseModal
      open={open}
      onClose={() => onClose(false)}
      title={roleInfo ? "ویرایش شریک" : "ایجاد شریک"}
      hasCloseIcon
    >
      <CreatePartnerForm
        roleInfo={roleInfo}
        onSuccess={() => {
          onClose(false);
          handleReload && handleReload();
        }}
      />
    </MuiBaseModal>
  );
}
